<!-- 导航下拉 -->
<template>
  <div class="cube-drop">
    <a-dropdown class="drop" :trigger="['click']">
      <div class="icon-box">
        <svg class="icon">
          <use xlink:href="#icon-suoyouchanpin"></use>
        </svg>
      </div>
      <template #overlay>
        <div class="cube-box">
          <div class="cube-panel">
            <div class="panel" v-for="(item, index) in list" :key="index">
              <div class="panel-title">{{ item.groupName }}</div>
              <div class="panel-list">
                <div
                  v-for="(it, key) in item.children"
                  :key="key + 100"
                  class="panel-list-item"
                  @click="handleClick(it)"
                >
                  <img
                    v-if="it.name == '引擎共建'"
                    src="https://ali-file-cdn.iol8.com/img/logo/twinslator/tw-logo.png"
                    width="40"
                    height="40"
                    class="margin-b-12"
                  />
                  <svg v-else :style="{ fill: it.fill }" aria-hidden="true">
                    <use :xlink:href="`#${it.icon}`" />
                  </svg>
                  <p>{{ it.name }}</p>
                </div>
              </div>
            </div>
          </div>
          <div class="more-box" @click="toAllService">
            <span>查看所有产品服务</span>
            <svg class="more-box-icon icon">
              <use xlink:href="#icon-youjiantou"></use>
            </svg>
          </div>
        </div>
      </template>
    </a-dropdown>
  </div>
</template>

<script>
  import { defineComponent } from 'vue'
  import { useRoute, useRouter } from 'vue-router'

  export default defineComponent({
    setup() {
      const route = useRoute() // 获取当前路由
      const router = useRouter() // 获取路由对象

      // 定义list
      const list = [
        {
          groupName: '',
          children: [
            {
              icon: 'icon-a-bianzu13',
              fill: '',
              name: '个人翻译',
              path: `/go/pe_pc_login/pe?redirect=translation&enterpriseId=${sessionStorage.getItem('enterpriseId')}`,
              type: 'external',
              auth: true,
            },
            {
              icon: 'icon-a-bianzu14',
              fill: '',
              name: '项目翻译',
              path: `/go/pe_pc_login/pe?redirect=project/join&enterpriseId=${sessionStorage.getItem('enterpriseId')}`,
              type: 'external',
              auth: true,
            },
            {
              icon: 'icon-a-bianzu15',
              fill: '#FF5757',
              name: '语言资产',
              path: `/go/pe_pc_login/pe?redirect=term/myterm&enterpriseId=${sessionStorage.getItem('enterpriseId')}`,
              type: 'external',
              auth: true,
            },
            {
              icon: 'icon-logo3',
              fill: '#D74590',
              name: '引擎共建',
              path: `/go/tw_pc_login/market?enterpriseId=${sessionStorage.getItem('enterpriseId')}`,
              type: 'external',
              auth: true,
            },
            {
              icon: 'icon-a-bianzu16',
              fill: '',
              name: 'AI工具包',
              path: `/go/iollab_pc_login/`,
              type: 'external',
              auth: true,
            },
          ],
        },
      ]

      const handleClick = (v) => {
        const { type, path, auth } = v
        if (!path) return
        // 外部链接
        if (type == 'external') {
          window.open(`${path}`, '_blank')
          return
        }
        // 内部链接
        router.push({ path })
      }

      const toAllService = () => {
        window.open(`/go/wp_pc_login/allService`, '_blank')
      }
      return {
        list,
        route,
        handleClick,
        toAllService,
      }
    },
  })
</script>

<style scoped lang="less">
  .cube-box {
    padding: 0;
    height: 280px;
    background-color: #fff;
    margin-top: 12px;
    overflow-y: auto;
    box-shadow: 0 2px 8px rgb(0 0 0 / 15%);
    -webkit-transform: translateZ(0);
    &::-webkit-input-placeholder {
      font-size: 14px;
      color: #818385;
    }
    &::-webkit-scrollbar {
      width: 7px;
      background-color: rgba(0, 0, 0, 0);
    }
    &::-webkit-scrollbar-thumb {
      background: #bfbfbf;
      border-radius: 10px;
      width: 7px;
    }
  }
  .cube-drop {
    .icon-box {
      width: 32px;
      height: 32px;
      cursor: pointer;
      outline: none;
      display: flex;
      align-items: center;
      justify-content: center;
      border-radius: 4px;
      &:hover {
        background-color: #f3f7ff;
      }
    }
    .bg-color.icon-box {
      svg {
        fill: #fff;
      }
      &:hover {
        background-color: rgba(255, 255, 255, 0.3);
      }
    }
    svg {
      width: 18px;
      height: 18px;
      outline: none;
    }
  }
  .cube-panel {
    user-select: none;
    width: 312px;
    .panel {
      padding: 20px 20px 15px;
      border-bottom: 1px solid #ebedf0;
      &:last-child {
        border-bottom: none;
      }
      .panel-title {
        font-size: 14px;
        color: #8589a0;
      }
      .panel-list {
        display: flex;
        justify-content: flex-start;
        flex-wrap: wrap;
        margin-top: 10px;
        .panel-list-item {
          padding: 10px 0px;
          height: 90px;
          width: 33.33%;
          text-align: center;
          cursor: pointer;
          &:hover {
            background: #f4f7ff;
            border-radius: 10px;
          }
          &:nth-of-type(3n) {
            margin-right: 0px;
          }
          svg {
            width: 40px;
            height: 40px;
            margin-bottom: 5px;
          }
          p:nth-of-type(1) {
            font-size: 14px;
            color: #161b36;
            line-height: 20px;
            margin-bottom: 2px;
          }
        }
      }
    }
  }
  .more-box {
    padding-top: 10px;
    text-align: center;
    font-size: 14px;
    font-family:
      'PingFang SC', 'Lantinghei SC', 'Microsoft YaHei', 'HanHei SC',
      'Helvetica Neue', 'Open Sans', 'Avenir', Helvetica, Arial, sans-serif;
    cursor: pointer;
    .more-box-icon {
      width: 12px;
      height: 12px;
    }
  }
</style>
